import React, { Component, PropTypes } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Button, Icon, Image, Menu } from 'semantic-ui-react'

import logo from '../../images/JamBonSWLogo.png'

import '../../../node_modules/semantic-ui-css/components/button.css'
import '../../../node_modules/semantic-ui-css/components/icon.css'
import '../../../node_modules/semantic-ui-css/components/image.css'
import '../../../node_modules/semantic-ui-css/components/menu.css'

export default class MenuComponent extends Component {
  static propTypes = {
    handleLogout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
  }

  buttonClassName () {
    const { handleLogout, isAuthenticated } = this.props
    if (isAuthenticated) {
      return (
        <Button
          className='right-border-rounded'
          color='yellow'
          floated='right'
          key={`Logout Button`}
          onClick={handleLogout}
        >
          <span
            className='hide-text-on-mobile'
          >Sign Out</span>
          <Icon className='mobile-only-icon hvr-icon-forward-login' name='sign out' />
        </Button>
      )
    }
    return null
  }

  render () {
    return (
      <Menu borderless widths={3}>
        <Menu.Item />
        <Menu.Item>
          <a href='http://www.jambonsw.com/'>
            <Image src={logo} className='logo' alt='logo' />
          </a>
        </Menu.Item>
        <Menu.Item position='right' className='padding-right'>
          <ReactCSSTransitionGroup
            className='menuContent'
            component='div'
            transitionName='menuContent'
            transitionEnterTimeout={600}
            transitionLeaveTimeout={600}
          >
            {this.buttonClassName()}
          </ReactCSSTransitionGroup>
        </Menu.Item>
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/MenuComponent.js